<script setup lang="ts">
import { RefundRequestEmbed } from '@/Pejer/tables/RefundRequests'

const props = defineProps<{
  payoutReason: RefundRequestEmbed.ListItem['payoutReason']
}>()

const reasonMap: Record<string, string> = {
  TransferExcessPayment: 'Overbetaling, refundering av overbetalt beløp',
  PaymentRefund: 'Refundering av betaling',
  KIDNotFound: 'Ugyldig KID-nummer',
  PaymentIsCancelled: 'Betalingen er kansellert',
}
</script>
<template>
  {{ reasonMap[props.payoutReason] ?? props.payoutReason }}
</template>
